import * as React from "react";
import { MediaQuery } from "@grandvisionhq/common";
import LocationSearchListLayout from "../../../LocationSearchListLayout/components/LocationSearchListLayout/LocationSearchListLayout.js";
import LocationSearch from "./LocationSearch.js";
const LocationSearchContainer = ({
  searchForm,
  loadingListItems,
  listItems,
  listTopContent,
  listInfoContent,
  mapContent,
  googleMapsId,
  showTabs,
  highlightPreferredStore,
  ...rest
}) => {
  const isMobile = MediaQuery.useIsPhone();
  const showPreferredStore = !listItems.length && !loadingListItems;
  return /* @__PURE__ */ React.createElement(
    LocationSearch,
    {
      ...rest,
      showTabs,
      searchForm,
      listTopContent: isMobile && listTopContent,
      scrollToHandlerId: "location-search-form",
      listContent: /* @__PURE__ */ React.createElement(
        LocationSearchListLayout,
        {
          googleMapsId,
          showLinkToMap: !isMobile,
          topContent: !isMobile && listTopContent ? listTopContent : null,
          searchForm,
          showTabs,
          infoContent: listInfoContent ?? null,
          loadingListItems,
          listItems,
          highlightPreferredStore: showPreferredStore && highlightPreferredStore
        }
      ),
      mapContent
    }
  );
};
export {
  LocationSearchContainer as default
};
//# sourceMappingURL=LocationSearchContainer.js.map
